const DefaultFieldTypeMap = {
  TextField: 'string',
  NumberField: 'numeric',
  TimelineField: 'timeline',
  PhotoField: 'photo',
  MultiSelectField: 'multi-select',
}
export default DefaultFieldTypeMap
